import Tray from './index'
import React from 'react'


const NetflixTray = (props) => {
  return (
    <div className="netflix-tray">
      <Tray {...props} netflix={true}/>
    </div>
  )
}


export default NetflixTray;
